import React from 'react';
import Typography from '@material-ui/core/Typography';
import { useQuery } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
        [theme.breakpoints.down('xs')]: {
            paddingLeft: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
    },
}))

const Past12MonthsEnquiries = () => {
    const classes = useStyles()

    const { data: { statistics } = {} } = useQuery({
        type: 'getOne',
        resource: 'dashboard/statistics',
    });

    if (statistics && statistics.direct_enquirers.value) {
        const title = `In the last 12 months, you have received ${statistics.direct_enquirers.value} ${statistics.direct_enquirers.value === 1  ? 'enquiry' : 'enquiries'}`

        return (
            <Typography className={classes.title}>{title}</Typography>
        )
    }

    return null
}

export default (Past12MonthsEnquiries)
